import { useTranslation } from 'react-i18next';

import styles from './VoiceInputButton.module.css';

/** 'hidden' сюда не доходит — отсутствие поддержки решает VoiceInput. */
export type VoiceButtonVisualState = 'available' | 'gated' | 'recording' | 'processing';

interface VoiceInputButtonProps {
  state: VoiceButtonVisualState;
  onPress: () => void;
}

const LABEL_KEY: Record<VoiceButtonVisualState, string> = {
  available: 'button.start',
  gated: 'button.gated',
  recording: 'button.stop',
  processing: 'button.processing',
};

// PARA-132 (AC-1, AC-15, AC-16) — кнопка микрофона. В состоянии gated она
// остаётся НАЖИМАЕМОЙ (ведёт в биллинг), поэтому блокировка выражена
// aria-disabled, а не атрибутом disabled: путь решения у пользователя есть.
export function VoiceInputButton({ state, onPress }: VoiceInputButtonProps): JSX.Element {
  const { t } = useTranslation('voice');

  return (
    <button
      type="button"
      className={`${styles.button} ${styles[state]}`}
      onClick={onPress}
      aria-label={t(LABEL_KEY[state])}
      aria-pressed={state === 'recording'}
      aria-disabled={state === 'gated'}
      disabled={state === 'processing'}
      data-testid="voice-input-button"
    >
      <svg className={styles.icon} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path
          d="M12 3a3 3 0 0 1 3 3v6a3 3 0 0 1-6 0V6a3 3 0 0 1 3-3Z"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinejoin="round"
        />
        <path
          d="M5.5 11.5a6.5 6.5 0 0 0 13 0M12 18v3"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
        />
      </svg>
    </button>
  );
}
